import { FC } from 'react'
import { useAppSelector } from 'src/redux/storeHooks'
import Loader from 'src/utils/Loader'
import TemplateAndPricing from '../TemplateAndPricing'
import ListingProfilesPreviousPage from '../listing-profiles-previous/ListingProfilesPreviousPage'
import { isListingProfileNewUiAllowlisted } from './rolloutConfig'

/**
 * Temporary route switch for /listing-profiles during staged rollout.
 */
const ListingProfilesRolloutRoute: FC = () => {
  const { fetchedUserAccountData } = useAppSelector((state) => state.userAccountData)

  if (!fetchedUserAccountData?.id) {
    return (
      <div className="d-flex align-items-center justify-content-center py-20">
        <Loader variant="section" />
      </div>
    )
  }

  if (isListingProfileNewUiAllowlisted(fetchedUserAccountData.email)) {
    return <TemplateAndPricing />
  }

  return <ListingProfilesPreviousPage />
}

export default ListingProfilesRolloutRoute
